import PropTypes from 'prop-types';

import { CustomTooltip } from 'src/components/CustomTooltip';

import { PROMPT_NODE_ID } from '../../../../const';

import { useStyles } from './useStyles';

export const PromptImageNode = ({ element, attributes, children }) => {
  const styles = useStyles();

  return (
    <CustomTooltip
      id={PROMPT_NODE_ID.image}
      className={styles.wrapper}
      title={element.tooltip}
    >
      <span
        className={styles.root}
        {...attributes}
      >
        {children}
      </span>
    </CustomTooltip>
  );
};

PromptImageNode.propTypes = {
  element: PropTypes.shape().isRequired,
  attributes: PropTypes.shape({}).isRequired,
  children: PropTypes.node,
};

PromptImageNode.defaultProps = {
  children: null,
};
